import { Component, EventEmitter, Output } from '@angular/core';
import { HomePageCardsModule } from '../home-page-cards/home-page-cards.module';
import { TranslateModule } from '@ngx-translate/core';

import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'app-dashboard-setup-checklist',
  templateUrl: './setup-checklist.component.html',
  styleUrls: ['./setup-checklist.component.scss'],
  providers: [],
  imports: [HomePageCardsModule, TranslateModule],
})
export class SetupChecklistComponent {
  @Output() chcklistVisible: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private readonly productAnalyticsService: ProductAnalyticsService) {}

  dismissChecklist() {
    this.productAnalyticsService.trackEvent('checklist', 'dashboard', 'dismissed');
    this.chcklistVisible.emit(false);
  }
}
